import { DefaultTheme } from 'styled-components';

export const baseTheme: DefaultTheme = {};
